import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { asapScheduler, Observable, scheduled, throwError } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AzureTokenRequest } from '../classes/authentication/azure-token-request';
import { MsalConfig } from '../classes/authentication/msal-config';
import { determineMSALConfigFile } from '../common/scope-utility';

const useImMemoryWebApi = !environment.production && environment.inMemoryWebApiEnabled;
const authToken = localStorage.getItem('access-token');
@Injectable({
  providedIn: 'root'
})
export class MsalConfigService {
  tokenRequest: AzureTokenRequest;

  constructor(private http: HttpClient, private msalService: MsalService) {
    if (!useImMemoryWebApi) {
      this.getTokenRequest().subscribe((tokenRequest: AzureTokenRequest) => (this.tokenRequest = tokenRequest));
    }
  }

  getMsalConfig(): Observable<MsalConfig> {
    return this.http.get<any>(determineMSALConfigFile()).pipe(
      catchError((error) => {
        console.error('Failed to load MSAL config:', error);
        return throwError(error);
      })
    );
  }

  getAzureToken(): Observable<string> {
    return useImMemoryWebApi
      ? scheduled([ authToken ], asapScheduler)
      : this.getTokenRequest().pipe(
          switchMap((tokenRequest: AzureTokenRequest) => this.msalService.acquireTokenSilent(tokenRequest)),
          map((authResult: AuthenticationResult) => authResult.accessToken),
          catchError((error) => {
            console.error('Failed to acquire Azure token:', error);
            return throwError(error);
          })
        );
  }

  getTokenRequest(): Observable<AzureTokenRequest> {
    return this.tokenRequest
      ? scheduled([ this.tokenRequest ], asapScheduler)
      : this.getMsalConfig().pipe(
          map((config) => ({
            scopes: config.guard.authRequest.scopes,
            redirectUri: config.auth.redirectUri,
            account: this.msalService.instance.getActiveAccount()
          }))
        );
  }
}
